module.exports = __webpack_public_path__ + "static/media/dropdown.b59c2dea.webp";